import { all, call, put, takeLatest } from "redux-saga/effects"

import { generateTree } from "utils/utils"

import { GET_DIVISIONS_WATCHER } from "./constants"

import { getDivisionsSuccess, getDivisionsFailed } from "./actions"
import {
  getDimensionsApi,
  getDivisionsApi,
} from "../../../../../utils/routes/routes-report"
import { isModuleBySlug } from "../../../../../utils/storage"
import { AMBASSADOR_USERS } from "../../../../../utils/constants"
import { filter, map } from "lodash"

export function* getDivisionsSaga(action) {
  try {
    const dataStatus = action.payload
    const [
      divisionsApi,
      //{ data: dimensionsApi },
      { data: ambassadorsApi },
    ] = yield all([
      call(getDivisionsApi, dataStatus),
      // call(getDimensionsApi, dataStatus),
      call(fetchGlobalApi, { method: "GET", endpoint: `ambassadors` }),
    ])

    let iteratorHere = divisionsApi.data
    const isAmbassador = isModuleBySlug(AMBASSADOR_USERS)
    if (validRole({ role: [1, 2, 3, 4] }) && isAmbassador) {
      iteratorHere = map(divisionsApi.data, (item) => {
        return {
          ...item,
          ambassadors: filter(
            ambassadorsApi.data.result.ambassadors,
            (ambassador) => {
              return ambassador.divisions.some(
                (amb) => amb.id_division === item.id
              )
            }
          ),
        }
      })
    }

    const result = {}

    if (dataStatus.is_engagement) {
      if (dataStatus.dimensionType == "Engagement") {
        result.metric = divisionsApi.measure_engagement
      } else {
        result.metric = divisionsApi.metric_total
      }
    } else {
      result.metric = divisionsApi.metric_total
    }

    result.dimensions = []
    result.divisions = divisionsApi.data
    result.divisions_drill_down =
      iteratorHere.length > 0
        ? generateTree("id", "id_parent", iteratorHere)
        : []
    yield put(getDivisionsSuccess(result))
  } catch (e) {
    yield put(getDivisionsFailed())
  }
}

// Individual exports for testing
export default function* widgetResultByDivisionEngagementSaga() {
  yield takeLatest(GET_DIVISIONS_WATCHER, getDivisionsSaga)
}
